import  { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { LockOutlined } from '@ant-design/icons';
import 'react-toastify/dist/ReactToastify.css';
import Logo from '../courses/student/logo.png'
const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const Role = localStorage.getItem('role')

  useEffect(()=>{

    if(Role !=null) {
        switch (Role) {
            case "ADMIN":
              navigate("/user/admin-home-page", { replace: true });
              break;

            case "INSTRUCTOR":
              navigate("/user/instructor-home-page", { replace: true });
              break;

            case "OPERATIONS":
              navigate("/user/operations-home-page", { replace: true });
              break;

            case "STUDENT":
              navigate("/user/student-home-page", { replace: true });
              break;

            default:
              throw new Error("Invalid role");
          }
    }
    
     if(token == null) {
    navigate('/user/sign_in')
  }

   
  },[])

  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);

  const isPasswordValid = form.newPassword.length >= 6;
  const isMatch = form.newPassword === form.confirmPassword;

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleBlur = e => {
    setTouched({ ...touched, [e.target.name]: true });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!token) {
      toast.error('Missing or invalid token');
      return;
    }
    if (!isPasswordValid || !isMatch) {
      toast.error('Please fix form errors before submitting');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/user/reset-password`, {
        token,
        newPassword: form.newPassword
      });

      if (response.data.success) {
        toast.success('Password reset successfully!');
        setTimeout(() => navigate('/user/sign_in'), 2000);
      } else {
        toast.error(response.data.message || 'Reset failed Please confirm with valid token...');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Reset failed Please confirm with valid token...');
    } finally {
      setLoading(false);
    } 
  };

 return (
  <div className="flex items-center justify-center min-h-screen px-4 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800">

   <ToastContainer
                       position="bottom-left"
                       autoClose={5000}
                       hideProgressBar={true}
                       newestOnTop={false}
                       closeOnClick
                       rtl={false}
                       pauseOnFocusLoss
                       draggable
                       pauseOnHover
                       theme="dark"
                       className="!mb-6 !ml-4"
                       toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                     />

    {/* Card */}
    <div className="w-full max-w-xl p-6 border shadow-2xl bg-white/10 backdrop-blur-xl rounded-2xl border-white/20">

      {/* Header */}
      <div className="mb-6 text-center">
        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-white rounded-full shadow-lg">
  <img
    src={Logo}
    alt="logo"
    className="object-contain h-14 w-14"
  />
</div>

        <h2 className="text-2xl font-extrabold text-white">
          Reset Password
        </h2>

        <p className="mt-2 text-sm text-gray-300">
          Enter your new password securely
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-6">

        {/* New Password */}
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-200">
            New Password
          </label>

          <div className="relative">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
              <LockOutlined />
            </span>

            <input
              type="password"
              name="newPassword"
              value={form.newPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter new password"
              className={`w-full pl-10 pr-4 py-3 rounded-lg bg-white/90 text-gray-800 border focus:outline-none transition-all duration-200 ${
                !touched.newPassword
                  ? "border-gray-300 focus:ring-2 focus:ring-blue-500"
                  : isPasswordValid
                  ? "border-green-500 focus:ring-2 focus:ring-green-500"
                  : "border-red-500 focus:ring-2 focus:ring-red-500"
              }`}
            />
          </div>

          {touched.newPassword && !isPasswordValid && (
            <p className="mt-1 text-sm text-red-400">
              Password must be at least 6 characters
            </p>
          )}
        </div>

        {/* Confirm Password */}
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-200">
            Confirm Password
          </label>

          <div className="relative">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
              <LockOutlined />
            </span>

            <input
              type="password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Confirm password"
              className={`w-full pl-10 pr-4 py-3 rounded-lg bg-white/90 text-gray-800 border focus:outline-none transition-all duration-200 ${
                !touched.confirmPassword
                  ? "border-gray-300 focus:ring-2 focus:ring-blue-500"
                  : isMatch
                  ? "border-green-500 focus:ring-2 focus:ring-green-500"
                  : "border-red-500 focus:ring-2 focus:ring-red-500"
              }`}
            />
          </div>

          {touched.confirmPassword && !isMatch && (
            <p className="mt-1 text-sm text-red-400">
              Passwords do not match
            </p>
          )}
        </div>

        {/* Button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 font-semibold text-white transition-all duration-300 rounded-lg shadow-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50"
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>

      </form>
    </div>
  </div>
);
};

export default ResetPassword;